var map = {
	"./30AugustBloodStem (1).jpeg": 12687,
	"./30AugustBloodStem (2).jpeg": 37168,
	"./Blood Stem Cell Donation Awareness seminar (2).jpeg": 67434,
	"./Blood Stem Cell Donation Awareness seminar.jpeg": 9375,
	"./WhatsApp Image 2025-01-30 at 1.39.14 PM.jpeg": 79318,
	"./WhatsApp Image 2025-01-30 at 1.39.21 PM.jpeg": 68546,
	"./WhatsApp Image 2025-01-30 at 1.39.22 PM (1).jpeg": 73875,
	"./WhatsApp Image 2025-01-30 at 1.39.22 PM.jpeg": 77197,
	"./WhatsApp Image 2025-01-30 at 1.39.23 PM.jpeg": 61632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48533;